import React from "react";
import styled from "styled-components";

function Input({ type, name, value, onChange, min, submit }) {
  return (
    <Container>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        min={min}
        cols="40"
        rows="5"
        required
        className={submit ? "submit-button" : ""}
      />
    </Container>
  );
}

export default Input;

const Container = styled.div`
  input {
    background-color: white;
    padding: 1rem;
    border: none;
    border-radius: 3px;
    height: 40px;
    width: 400px;
    font-size: 1rem;
    &:focus {
      background-color: #e9e9e9;
      font-family: system-ui;
    }
  }

  .submit-button {
    font-size: 1.1rem;
    color: var(--color-white);
    background: var(--color-primary);
    cursor: pointer;
    position: relative;
    z-index: 1;
    font-weight: bold;
    padding: 0 3.4rem;
    margin: 1rem 0;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 1px;
  }

  .submit-button:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: 768px) {
    input {
      width: 300px;
    }
  }
`;
